import Vue from 'vue'
import VueI18n from 'vue-i18n'

import amea_ar from './i18n/amea_ar'
import amea_en from './i18n/amea_en'
import amea_ja from './i18n/amea_ja'
import amea_fil from './i18n/amea_fil'
import amea_ms from './i18n/amea_ms'
import americas_en from './i18n/americas_en'
import americas_pt from './i18n/americas_pt'
import europe_en from './i18n/europe_en'
import europe_fr from './i18n/europe_fr'
import europe_pl from './i18n/europe_pl'
import portugal_en from './i18n/portugal_en'
import portugal_pt from './i18n/portugal_pt'
import europe_nl from './i18n/europe_nl'
import hungary_en from './i18n/hungary_en'
import hungary_hu from './i18n/hungary_hu'
import italy_en from './i18n/italy_en'
import italy_it from './i18n/italy_it'
import india_en from './i18n/india_en'
import spain_en from './i18n/spain_en'
import spain_es from './i18n/spain_es'
import germany_de from './i18n/germany_de'
import germany_en from './i18n/germany_en'
import uk_en from './i18n/uk_en'

/**
 * Config
 */
Vue.use(VueI18n)

/**
 * Export
 */
export default new VueI18n({
	locale: 'UK_EN',
	fallbackLocale: 'UK_EN',
	messages: {
		AMEA_AR: {
			lang: amea_ar
		},
		AMEA_EN: {
			lang: amea_en
		},
		AMEA_JA: {
			lang: amea_ja
		},
		AMEA_FIL: {
			lang: amea_fil
		},
		AMEA_MS: {
			lang: amea_ms
		},
		AMERICAS_EN: {
			lang: americas_en
		},
		AMERICAS_PT: {
			lang: americas_pt
		},
		EUROPE_EN: {
			lang: europe_en
		},
		EUROPE_FR: {
			lang: europe_fr
		},
		EUROPE_NL: {
			lang: europe_nl
		},
		EUROPE_PL: {
			lang: europe_pl
		},
		HUNGARY_EN: {
			lang: hungary_en
		},
		HUNGARY_HU: {
			lang: hungary_hu
		},
		INDIA_EN: {
			lang: india_en
		},
		ITALY_EN: {
			lang: italy_en
		},
		ITALY_IT: {
			lang: italy_it
		},
		PORTUGAL_EN: {
			lang: portugal_en
		},
		PORTUGAL_PT: {
			lang: portugal_pt
		},
		SPAIN_EN: {
			lang: spain_en
		},
		SPAIN_ES: {
			lang: spain_es
		},
		GERMANY_EN: {
			lang: germany_en
		},
		GERMANY_DE: {
			lang: germany_de
		},		
		UK_EN: {
			lang: uk_en
		}
	}
})